import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "news-summary" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "news-meta" }
const _hoisted_5 = { class: "news-author" }
const _hoisted_6 = {
  key: 0,
  class: "news-tags"
}
const _hoisted_7 = {
  key: 2,
  class: "edit-info"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Markdown = _resolveComponent("Markdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.article.Summary), 1),
    (_ctx.article.Media && !_ctx.extractYoutubeVideoId(_ctx.article.Media))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.article.Media,
          alt: "News Thumbnail",
          class: "news-thumbnail"
        }, null, 8, _hoisted_2))
      : (_ctx.article.Media && _ctx.extractYoutubeVideoId(_ctx.article.Media))
        ? (_openBlock(), _createElementBlock("iframe", {
            key: 1,
            src: `https://www.youtube.com/embed/${_ctx.extractYoutubeVideoId(_ctx.article.Media)}`,
            class: "news-thumbnail",
            allowfullscreen: ""
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _cache[0] || (_cache[0] = _createTextVNode("By ")),
        _createVNode(_component_router_link, {
          to: `/profiles/${_ctx.article.Author}`,
          target: "_blank"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.article.Author), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createTextVNode(" on " + _toDisplayString(_ctx.formatDate(_ctx.article.CreatedAt)), 1)
      ]),
      (_ctx.article.Games && _ctx.article.Games.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.Games, (game) => {
              return (_openBlock(), _createElementBlock("span", {
                key: game,
                class: "news-tag"
              }, _toDisplayString(_ctx.gameNames.get(game)), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Markdown, {
      source: _ctx.article.Content,
      class: "news-content"
    }, null, 8, ["source"]),
    (_ctx.article.EditedAt || _ctx.article.Editor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createTextVNode(" Edited ")),
          (_ctx.article.EditedAt)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, "on " + _toDisplayString(_ctx.formatDate(_ctx.article.EditedAt)), 1))
            : _createCommentVNode("", true),
          _cache[3] || (_cache[3] = _createTextVNode()),
          (_ctx.article.Editor)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _cache[1] || (_cache[1] = _createTextVNode("by ")),
                _createVNode(_component_router_link, {
                  to: `/profiles/${_ctx.article.Editor}`,
                  target: "_blank"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.article.Editor), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}